import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import LoginUsername from './pages/LoginUsername';
import LoginPassword from './pages/LoginPassword';
import { SessionProvider } from "./contexts/SessionContext";
import ConsentScreen from "./pages/Consent";
import ErrorPage from "./pages/ErrorPage";
import './i18n';
import LoginMFA from "./pages/LoginMFA";

function App() {
  return (
    <div className="App">
      <SessionProvider>
        {/* Main Container */}
        <div className="container">
          <div className="content-box">
            <Routes>
              <Route path="/login" element={<LoginUsername />} />
              <Route path="/login/password" element={<LoginPassword />} />
              <Route path="/login/mfa" element={<LoginMFA />} />
              <Route path="/login/consent" element={<ConsentScreen />} />
              <Route path="/login/error" element={<ErrorPage />} />
              {/* Redirect all undefined routes to /login */}
              <Route path="*" element={<Navigate to="/login/error" replace />} />
            </Routes>
          </div>
        </div>
      </SessionProvider>
    </div>
  );
}

export default App;